import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';
import {ServiceProviderWithBrands} from '../models/serviceProvider.model';

export class GetServiceProviderByIdUseCase {
  constructor (private serviceProviderRepository: ServiceProviderRepository) {}

  async execute (id: string): Promise<ServiceProviderWithBrands> {
    return await this.serviceProviderRepository.getById(id);
  }
}
